/* eslint-disable */
import Swiper from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const elements = document.querySelectorAll('[data-js-module="Carousel"]');

elements.forEach(element => {
  const swiper = new Swiper(`#${element.id}`, {
    modules: [A11y, Navigation, Pagination],
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 16,
    breakpoints: {
      600: {
          slidesPerView: 2,
          slidesPerGroup: 2
      },
      960: {
          slidesPerView: 3.5,
          slidesPerGroup: 3.5
      },
      1280: {
          slidesPerView: 4,
          slidesPerGroup: 4
      },
    },
    pagination: {
      el: ".pagination__list",
      clickable: true,
      renderBullet: function (index, className) {
        return `<button class="pagination__list-number type-captions-2 ${className}">${index + 1}</button>`;
      }
    },
    navigation: {
      nextEl: ".next",
      prevEl: ".previous",
    },
    grabCursor: true
  });
});
